import { EMethod } from "../types";
import { API_VERSION } from "../constants";

export const CORPORATION_ENDPOINT = {
  USER_ASSOCIATED_CORP_LIST: {
    method: EMethod.GET,
    url: "/corp/associated",
    version: API_VERSION.V0,
  },
  GET_CORP_EMPLOYEE_ACCESS: {
    method: EMethod.GET,
    url: "/corp/member/employee/access",
    version: API_VERSION.V0,
  },
  GET_SEARCH_CORP: {
    method: EMethod.GET,
    url: "/corp/search",
    version: API_VERSION.V0,
  },
  GET_CORP_STAFF_MEMBER: {
    method: EMethod.GET,
    url: "/corp/member/staff",
    version: API_VERSION.V0,
  },
  GET_CORP_CLIENT_MEMBER: {
    method: EMethod.GET,
    url: "/corp/member/client",
    version: API_VERSION.V0,
  },
  GET_CORP_EMPLOYEE_MEMBER: {
    method: EMethod.GET,
    url: "/corp/member/employee",
    version: API_VERSION.V0,
  },
  GET_CORP_STAFF_MEMBER_FILTER: {
    method: EMethod.GET,
    url: "/corp/member/staff/filter",
    version: API_VERSION.V0,
  },
  UPDATE_EMPLOYEE_ACCESS: {
    method: EMethod.PUT,
    url: "/corp/member/employee/access",
    version: API_VERSION.V0,
  },
  CREATE_BUSINESS_ESTABLISHMENT: {
    method: EMethod.POST,
    url: "/corp/business-establishment",
    version: API_VERSION.V0,
  },
  GET_BUSINESS_ESTABLISHMENT_LIST: {
    method: EMethod.GET,
    url: "/corp/business-establishment/search",
    version: API_VERSION.V0,
  },
  DUPLICATE_BUSINESS_ESTABLISHMENT: {
    method: EMethod.POST,
    url: "/corp/business-establishment/duplicate",
    version: API_VERSION.V0,
  },
  DELETE_BUSINESS_ESTABLISHMENT: {
    method: EMethod.DEL,
    url: "/corp/business-establishment",
    version: API_VERSION.V0,
  },
  ADD_CORP_MEMBER: {
    method: EMethod.POST,
    url: "/corp/member",
    version: API_VERSION.V0,
  },
  REMOVE_CORP_MEMBER: {
    method: EMethod.POST,
    url: "/corp/member/remove",
    version: API_VERSION.V0,
  },
  UPDATE_PROFILE_PICTURE: {
    method: EMethod.POST,
    url: "/corp/profile-picture",
    version: API_VERSION.V0,
  },
  ADD_CORP: {
    method: EMethod.POST,
    url: "/corp",
    version: API_VERSION.V0,
  },
  GET_CHECK_NTA_NUMBER: {
    method: EMethod.GET,
    url: "/corp/check-nta",
    version: API_VERSION.V0,
  },
  CREATE_ORGANIZATION: {
    method: EMethod.POST,
    url: "/corp/organization",
    version: API_VERSION.V0,
  },
  GET_ORGANIZATION_LIST: {
    method: EMethod.GET,
    url: "/corp/organization/search",
    version: API_VERSION.V0,
  },
  DUPLICATE_ORGANIZATION: {
    method: EMethod.POST,
    url: "/corp/organization/duplicate",
    version: API_VERSION.V0,
  },
  DELETE_ORGANIZATION: {
    method: EMethod.DEL,
    url: "/corp/organization",
    version: API_VERSION.V0,
  },
  GET_CORPORATION_BASIC_INFO: {
    method: EMethod.GET,
    url: "/corp/basic-information",
    version: API_VERSION.V0,
  },
  GET_CORPORATION_PROFILE_INFO: {
    method: EMethod.GET,
    url: "/corp",
    version: API_VERSION.V0,
  },
  SEARCH_TRAIN_STATIONS: {
    method: EMethod.GET,
    url: "/corp/train-station",
    version: API_VERSION.V0,
  },
  UPDATE_CORPORATION_BASIC_INFO: {
    method: EMethod.PATCH,
    url: "/corp/basic-information",
    version: API_VERSION.V0,
  },
  LEAVE_CORP: {
    method: EMethod.POST,
    url: "/corp/leave",
    version: API_VERSION.V0,
  },
  GET_JOB_LISTING_LIST: {
    method: EMethod.GET,
    url: "/corp/job-listing/search",
    version: API_VERSION.V0,
  },
  GET_JOB_LISTING_WORKING_HOURS: {
    method: EMethod.GET,
    url: "/corp/job-listing/working-hours",
    version: API_VERSION.V0,
  },
  ADD_JOB_LISTING_WORKING_HOURS: {
    method: EMethod.POST,
    url: "/corp/job-listing/working-hours",
    version: API_VERSION.V0,
  },
  UPDATE_JOB_LISTING_WORKING_HOURS: {
    method: EMethod.PUT,
    url: "/corp/job-listing/working-hours",
    version: API_VERSION.V0,
  },
  DELETE_JOB_LISTING_WORKING_HOURS: {
    method: EMethod.DEL,
    url: "/corp/job-listing/working-hours",
    version: API_VERSION.V0,
  },
  DELETE_JOB_LISTING: {
    method: EMethod.DEL,
    url: "/corp/job-listing",
    version: API_VERSION.V0,
  },
  DUPLICATE_JOB_LISTING: {
    method: EMethod.POST,
    url: "/corp/job-listing/duplicate",
    version: API_VERSION.V0,
  },
  CREATE_JOB_LISTING: {
    method: EMethod.POST,
    url: "/corp/job-listing",
    version: API_VERSION.V0,
  },
  GET_JOB_LISTING_EXPERIENCE: {
    method: EMethod.GET,
    url: "/corp/job-listing/experience",
    version: API_VERSION.V0,
  },
  GET_JOB_LISTING_CERTIFICATION: {
    method: EMethod.GET,
    url: "/corp/job-listing/certification",
    version: API_VERSION.V0,
  },
  UPDATE_JOB_LISTING_EXPERIENCE: {
    method: EMethod.PUT,
    url: "/corp/job-listing/experience",
    version: API_VERSION.V0,
  },
  UPDATE_JOB_LISTING_CERTIFICATION: {
    method: EMethod.PUT,
    url: "/corp/job-listing/certification",
    version: API_VERSION.V0,
  },
  DELETE_JOB_LISTING_EXPERIENCE: {
    method: EMethod.DEL,
    url: "/corp/job-listing/experience",
    version: API_VERSION.V0,
  },
  DELETE_JOB_LISTING_CERTIFICATION: {
    method: EMethod.DEL,
    url: "/corp/job-listing/certification",
    version: API_VERSION.V0,
  },
  GET_DETAIL_BUSINESS_ESTABLISHMENT: {
    method: EMethod.GET,
    url: "/corp/business-establishment",
    version: API_VERSION.V0,
  },
  UPDATE_BUSINESS_ESTABLISHMENT: {
    method: EMethod.PATCH,
    url: "/corp/business-establishment",
    version: API_VERSION.V0,
  },
  UPDATE_BUSINESS_ESTABLISHMENT_INVOICE: {
    method: EMethod.PATCH,
    url: "/corp/business-establishment/invoice",
    version: API_VERSION.V0,
  },
  UPDATE_ORGANIZATION_INVOICE: {
    method: EMethod.PATCH,
    url: "/corp/business-establishment/invoice",
    version: API_VERSION.V0,
  },
  GET_DETAIL_JOB_LISTING: {
    method: EMethod.GET,
    url: "/corp/job-listing",
    version: API_VERSION.V0,
  },
  UPDATE_JOB_LISTING: {
    method: EMethod.PATCH,
    url: "/corp/job-listing",
    version: API_VERSION.V0,
  },
  UPDATE_JOB_LISTING_QUALIFICATION: {
    method: EMethod.PUT,
    url: "/corp/job-listing/qualification",
    version: API_VERSION.V0,
  },
  UPLOAD_JOB_LISTING_IMAGE: {
    method: EMethod.PUT,
    url: "/corp/job-listing/image",
    version: API_VERSION.V0,
  },
  DELETE_JOB_LISTING_IMAGE: {
    method: EMethod.DEL,
    url: "/corp/job-listing/files/job",
    version: API_VERSION.V0,
  },
  GET_INDEED_CATEGORY: {
    method: EMethod.GET,
    url: "/corp/indeed-category",
    version: API_VERSION.V0,
  },
  DELETE_CORP: {
    method: EMethod.DEL,
    url: "/corp",
    version: API_VERSION.V0,
  },
  PUBLISH_JOB_LISTING: {
    method: EMethod.PUT,
    url: "/corp/job-listing/publish",
    version: API_VERSION.V0,
  },
  GENERATE_JOB_LISTING_BROCHURE: {
    method: EMethod.POST,
    url: "/corp/job-listing/brochure",
    version: API_VERSION.V0,
  },
  GET_JOB_LISTING_BROCHURE: {
    method: EMethod.GET,
    url: "/corp/job-listing/brochure",
    version: API_VERSION.V0,
  },
  GET_JOB_LISTING_FACILITY: {
    method: EMethod.GET,
    url: "/corp/job-listing/facilities",
    version: API_VERSION.V0,
  },
  UPDATE_JOB_LISTING_FACILITY: {
    method: EMethod.PUT,
    url: "/corp/job-listing/facilities",
    version: API_VERSION.V0,
  },
  DELETE_JOB_LISTING_FACILITY: {
    method: EMethod.DEL,
    url: "/corp/job-listing/facilities",
    version: API_VERSION.V0,
  },
  GET_STAFF_STATUS_LIST: {
    method: EMethod.GET,
    url: "/corp/member/staff/status/list",
    version: API_VERSION.V0,
  },
  GET_STAFF_STATUS_DETAIL: {
    method: EMethod.GET,
    url: "/corp/member/staff/status/{idStaffStatus}",
    version: API_VERSION.V0,
  },
  ADD_STAFF_STATUS: {
    method: EMethod.POST,
    url: "/corp/member/staff/status",
    version: API_VERSION.V0,
  },
  UPDATE_STAFF_STATUS: {
    method: EMethod.PATCH,
    url: "/corp/member/staff/status",
    version: API_VERSION.V0,
  },
  REMOVE_CURRENT_STAFF_STATUS: {
    method: EMethod.DEL,
    url: "/corp/member/staff/status/remove-current",
    version: API_VERSION.V0,
  },
  GET_DETAIL_ORGANIZATION: {
    method: EMethod.GET,
    url: "/corp/organization",
    version: API_VERSION.V0,
  },
  UPDATE_ORGANIZATION: {
    method: EMethod.PATCH,
    url: "/corp/organization",
    version: API_VERSION.V0,
  },
  GET_ORGANIZATION_FACILITY: {
    method: EMethod.GET,
    url: "/corp/organization/facilities",
    version: API_VERSION.V0,
  },
  UPDATE_ORGANIZATION_FACILITY: {
    method: EMethod.PUT,
    url: "/corp/organization/facilities",
    version: API_VERSION.V0,
  },
  DELETE_ORGANIZATION_FACILITY: {
    method: EMethod.DEL,
    url: "/corp/organization/facilities",
    version: API_VERSION.V0,
  },
  GET_CLIENT_STAKEHOLDER: {
    method: EMethod.GET,
    url: "/corp/member/stake-holder",
    version: API_VERSION.V0,
  },
  UPLOAD_ORGANIZATION_IMAGE_PRODUCT: {
    method: EMethod.POST,
    url: "/corp/organization/product",
    version: API_VERSION.V0,
  },
  UPLOAD_ORGANIZATION_IMAGE_EXTERIOR: {
    method: EMethod.POST,
    url: "/corp/organization/exterior-view",
    version: API_VERSION.V0,
  },
  DELETE_ORGANIZATION_IMAGE_PRODUCT: {
    method: EMethod.DEL,
    url: "/corp/organization/product",
    version: API_VERSION.V0,
  },
  DELETE_ORGANIZATION_IMAGE_EXTERIOR: {
    method: EMethod.DEL,
    url: "/corp/organization/exterior-view",
    version: API_VERSION.V0,
  },
  GET_ACTIVE_VACANCIES: {
    method: EMethod.POST,
    url: "/corp/active-vacancies/list",
    version: API_VERSION.V0,
  },
  DELETE_ACTIVE_VACANCIES: {
    method: EMethod.DEL,
    url: "/corp/active-vacancies",
    version: API_VERSION.V0,
  },
  UPDATE_ACTIVE_VACANCIES_SLOT: {
    method: EMethod.POST,
    url: "/corp/active-vacancies/update-slot",
    version: API_VERSION.V0,
  },
  GET_ACTIVE_VACANCIES_SLOT_DETAILS: {
    method: EMethod.GET,
    url: "/corp/active-vacancies/slot-details",
    version: API_VERSION.V0,
  },
  DECREASE_JOB_LISTING_SLOT: {
    method: EMethod.POST,
    url: "/corp/job-listing/decrease-slot",
    version: API_VERSION.V0,
  },
  GET_CORP_GLOBAL_LIST: {
    method: EMethod.POST,
    url: "/corp/global/get",
    version: API_VERSION.V0,
  },
  EXPORT_ACTIVE_VACANCY: {
    method: EMethod.POST,
    url: "/corp/active-vacancies/export",
    version: API_VERSION.V0,
  },
  EXPORT_ACTIVE_VACANCY_SUMMARY: {
    method: EMethod.POST,
    url: "/corp/active-vacancies/export-summary",
    version: API_VERSION.V0,
  },
  GET_ADDRESS_BY_ZIP_CODE: {
    method: EMethod.GET,
    url: "/corp/zip-code",
    version: API_VERSION.V0,
  },
  GET_INDUSTRIAL_ACCIDENT_COMPENSATION: {
    method: EMethod.GET,
    url: "/corp/business-establishment/industrial-accident",
    version: API_VERSION.V0,
  },
  SEARCH_EMPLOYMENT_SECURITY_JOB: {
    method: EMethod.GET,
    url: "/corp/job-listing/job-employment-security-list",
    version: API_VERSION.V0,
  },
  SEARCH_BASIC_WAGE_JOB: {
    method: EMethod.GET,
    url: "/corp/job-listing/job-employment-basic-wage-list",
    version: API_VERSION.V0,
  },
};
